var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outlined":"","dense":"","disabled":_vm.disabled,"label":_vm.labelRequired,"value":_vm.value,"rules":_vm.rules,"type":_vm.type,"hide-details":_vm.hideDetails},on:{"input":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }